// extracted by mini-css-extract-plugin
export default {"message":"Loader_message__44Nh+","spinner":"Loader_spinner__UYggT","spin":"Loader_spin__moMp8"};